module.exports = __webpack_public_path__ + "img/夢莎逆時雙效潔面乳Ⅱ.683a3dcb.png";